import { Container, Row } from "react-bootstrap";
import ProjectBlock from "./projectBlock";

const cyberedThumb = require('../assets/images/cybered.png');
const rssaThumb = require('../assets/images/rssa.png');

function MobileProjects() {
	return (<>
		<section>
			<header className="major">
				<h2>Projects I work on</h2>
			</header>
			<Container style={{ padding: "0.5em" }}>
				<Row>
					<ProjectBlock url="https://shahanm.github.io/cyberEd/" name="CyberED"
						cover={cyberedThumb} alt="A screenshot of an example program in Scratch"
						desc="The CyberEd project is a NSF EAGER project (2039616) lead by
						PI Dr. Nicole Bannister and Co-PIs Dr. Kelly Caine and Dr. Bart Knijnenburg.
						The goal of the project is equip middle school students with necessary skills
						in cyber-security best practices and everyday AI grounded in their math folk-model." />
				</Row>
				<Row style={{ marginTop: "1.3em" }}>
					<ProjectBlock url="https://rssa.recsys.dev" name="RSSA"
						cover={rssaThumb} alt="Screenshot of the RSSA Preference Elicatation Tool"
						desc="Recommender Systems for Self Actualization is Dr. Knijnenburg's NSF career Award (2045153).
							The group studies ways recommender systems can provide users with explanations on their preferences
							thus leading to self actualization." />
				</Row>
				{/* <Row style={{ marginTop: "1.3em" }}>
					<ProjectBlock url="" name="HDT"
						cover="" alt=""
						desc="The Human Digital Twin team explores avatars that are realistic and represents a 
							version of ourself in virtual spaces." />
				</Row>
				<Row style={{ marginTop: "1.3em" }}>
					<ProjectBlock url="" name="SRC-CoDE"
						cover="" alt=""
						desc="The Scaffolding Requirement Comprehension with Cotext Dependent Ethics (SRC-CoDE) is my project
						to study the impact of personalization on the understanding of requirements in software development." />
				</Row> */}
			</Container>
		</section>
	</>)
}

export default MobileProjects;